import "./style.css";
import { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, ThemeProvider, createTheme } from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import logo from '../../images/logo.png'
import logo2 from '../../images/logo2.png'
import { Link, useLocation } from "react-router-dom";
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1200,
      lg: 1280,
    },
  },
});

function Header() {

 

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [activeLink, setActiveLink] = useState("home");



  const location = useLocation();

  const currentPath = location.pathname;

  useEffect(() => {
    setActiveLink(currentPath === "/" ? "home" : currentPath.slice(1));
  }, [currentPath]);
  
  useEffect(() => {
      const pageTitle = location.pathname.split('/').pop();
      if (pageTitle===""){
        // eslint-disable-next-line no-useless-concat
        document.title =  'Mascotte'; 
      }else{
      document.title = `Mascotte - ${pageTitle.replace(/%20/g, ' ')}`; 
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <ThemeProvider theme={customTheme}>
      <div className={
                    activeLink === "home" ? "header " : "header black"
                  } id="header">
        <div className="navbar">
          <a href="/">
    {activeLink==='home'?(
     <img src={logo} alt="logo" className="logo"/>
    ):(
      <img src={logo2} alt="logo" className="logo"/>
    )
    }
        </a>
          <div className="navbarLink">
            <ol className={isOpen ? "none" : "linkList"}>
              <li>
                <Link
                  to="/"
                  className={
                    activeLink === "home" ? "navLink  active" : "navLink black"
                  }
                >
                  ACCeuil
                </Link>
              </li>
             
              <li>
                <Link
                  className={
                    activeLink === "menu" || activeLink === "home" ? "navLink black active2 " : "navLink black"
                  }
                  to="/menu"
                >
                  menu
                </Link>
              </li>
              <li>
                <Link
                  className={
                    activeLink === "info"|| activeLink === "home"
                      ? "navLink black active2 "
                      : "navLink black"
                  }
                  to="/info"
                >
                info
                </Link>
              </li>
             
              <li>
                <div className={activeLink === "home"?"socialLinks":"socialLinks blackLink"}>
                   <a href="https://glovoapp.com/tn/en/sfax/la-mascotte-sfx/" target="_blank" rel="noreferrer"> order online</a>
                </div>
              </li>
            </ol>
          
          </div>
          <IconButton
            sx={{
              display: {
                lg: "none",
                md: "none",
                sm: "inline-block",
                xs: "inline-block",
              },
              top: 2,
              right: "10px",
              zIndex: 99,
            }}
            onClick={toggleMenu}
            
          >
            {!isOpen ? (
              <MenuIcon
                id="openIcon"
               color="warning"
                fontSize="medium"
              />
            ) : (
              <CloseIcon
                id="closeIcon"
               color="warning"
                fontSize="medium"
              />
            )}
          </IconButton>
          <div className={isOpen ? "linkMenu show" : "linkMenu"}>
            
            <ol id="navMenu">
              <li>
                <a
                  className={
                    activeLink === "home" ? "navLink active" : "navLink"
                  }
                  href="/"
                >
                 acceuil
                </a>
              </li>
             
              <li className="separation"></li>
              <li>
                <a
                  className={
                    activeLink === "menu" ? "navLink active" : "navLink"
                  }
                  href="/menu"
                >
                  menu
                </a>
              </li>
              <li className="separation"></li>
              <li>
                <a
                  className={
                    activeLink === "info" ? "navLink active" : "navLink"
                  }
                  href="/info"
                >
                  info
                </a>
              </li>
              
              <li>
                <div className="socialLinks">
                <span>
              <a href="tel:52 735 777" className="socialLink">
              <PhoneAndroidIcon color="warning"
              />
              </a>
            </span>
            <span>
            <a href="https://www.facebook.com/profile.php?id=100067945710825" className="socialLink">
                    <FacebookIcon  color="warning"/>
                  </a>
            </span>
            <span>
            <a href="https://www.instagram.com/lamascotte_cafe_resto?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className="socialLink">
                    <InstagramIcon  color="warning"/>
                  </a>
            </span>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
export default Header;
